<template>
  <div>
    <!-- USER DETAIL -->
    <div class="pt-4-5 pb-4">
      <div class="rounded-circle overflow-hidden mx-auto mb-3" style="width: 70px;height: 70px;;">
        <img class="img-fit" :src="getCurrentUser.avatar" />
      </div>
      <div class="text-center mx-auto">
        <p class="sub-heading-1-2 mb-0">{{ fullName }}</p>
        <p class="body-2 mb-0">{{ getCurrentUser.email }}</p>
      </div>
    </div>

    <!-- MEMBERSHIP DETAIL -->
    <a v-if="$isNotEmptyV2(membership) && ($showHotelMembershipPoint().trx || $showHotelMembershipPoint().xp)"
      :href="$getCommunityUrl('/account/member')" 
      target="_blank">
      <div 
        class="nav-membership-bg px-3 w-100" 
        :style="{ 'background-color': membership.current_membership.card_color_accent}">
        <div class="d-flex align-items-center justify-content-between mb-2-5">
          <p class="body-1-4 text-white mb-0">{{ membership.current_membership.card_name }}</p>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.16393 13.1713C4.96523 12.9765 4.94716 12.6717 5.10974 12.4569L5.16393 12.3953L9.64894 7.9987L5.16393 3.60205C4.96523 3.40725 4.94716 3.10242 5.10974 2.88762L5.16393 2.82607C5.36264 2.63128 5.67358 2.61357 5.8927 2.77295L5.95547 2.82607L10.8361 7.61071C11.0348 7.80551 11.0528 8.11034 10.8903 8.32514L10.8361 8.38669L5.95547 13.1713C5.73689 13.3856 5.38251 13.3856 5.16393 13.1713Z" fill="white"/>
          </svg>
        </div>
        <div class="d-flex justify-content-between">
          <div v-if="$showHotelMembershipPoint().trx">
            <p class="body-3-1 text-white mb-0">Transaction Points</p>
            <div class="d-flex align-items-center">
              <img class="img-fit flex-0 mr-1" src="../../assets/img/icon/point.png" style="height: 16px;width: 16px">
              <p class="font-lato text-14 text-white mb-0">{{ membership.point_accumulation }}</p>
            </div>
          </div>
          <div v-if="$showHotelMembershipPoint().xp">
            <p class="body-3-1 text-white mb-0">Experience Points</p>
            <div class="d-flex align-items-center">
              <img class="img-fit flex-0 me-6" src="../../assets/img/icon/experience-point.png" style="height: 16px;width: 16px">
              <p class="font-lato text-14 text-white mb-0">{{ membership.xp_point }}</p>
            </div>
          </div>
        </div>
      </div>
    </a>

    <!-- MEMBERSHIP MENU -->
    <a v-if="$isNotEmptyV2(membership)" class="body-2-4 p-3 d-flex align-items-center justify-content-left menu-account-item" :href="$getCommunityUrl('/account/member')" target="_blank">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M9.126 16.73C9.618 17.21 10.41 17.20 10.898 16.71L11.5 16.11C11.966 15.65 12.611 15.38 13.269 15.38H14.127C14.822 15.38 15.387 14.82 15.387 14.12V13.26C15.387 12.60 15.645 11.97 16.117 11.50L16.717 10.90C16.961 10.65 17.092 10.33 17.091 9.997C17.090 9.662 16.958 9.346 16.719 9.107L16.118 8.506C15.645 8.030 15.387 7.403 15.387 6.736V5.880C15.387 5.185 14.822 4.620 14.127 4.620H13.270C12.603 4.620 11.975 4.361 11.503 3.892L10.901 3.289C10.400 2.793 9.601 2.796 9.112 3.288L8.513 3.889C8.035 4.362 7.407 4.620 6.742 4.620H5.885C5.190 4.621 4.625 5.186 4.625 5.880V6.734C4.625 7.402 4.366 8.029 3.896 8.502L3.305 9.095C2.798 9.605 2.800 10.404 3.293 10.893L3.895 11.495C4.366 11.968 4.625 12.596 4.625 13.263V14.122C4.625 14.817 5.190 15.382 5.885 15.382H6.740C7.409 15.382 8.036 15.642 8.509 16.112L9.110 16.712C9.115 16.717 9.120 16.723 9.126 16.73ZM10.004 18.336C9.365 18.336 8.726 18.094 8.237 17.609L7.625 16.998C7.389 16.763 7.074 16.633 6.739 16.633H5.884C4.500 16.633 3.375 15.507 3.375 14.123V13.264C3.375 12.929 3.244 12.615 3.009 12.378L2.410 11.780C1.437 10.812 1.425 9.235 2.381 8.252L3.010 7.621C3.244 7.385 3.375 7.070 3.375 6.735V5.881C3.375 4.497 4.500 3.372 5.883 3.371H6.742C7.076 3.371 7.391 3.240 7.630 3.004L8.226 2.407C9.200 1.426 10.793 1.421 11.775 2.397L12.384 3.007C12.620 3.241 12.935 3.371 13.270 3.371H14.127C15.511 3.371 16.637 4.497 16.637 5.881V6.737C16.637 7.071 16.767 7.387 17.002 7.624L17.601 8.223C18.075 8.694 18.338 9.323 18.341 9.994C18.343 10.665 18.084 11.296 17.612 11.772L17.001 12.381C16.767 12.617 16.637 12.931 16.637 13.266V14.123C16.637 15.507 15.511 16.633 14.128 16.633H13.268C12.938 16.633 12.616 16.766 12.382 16.998L11.783 17.597C11.294 18.089 10.649 18.336 10.004 18.336Z"
          fill="#4C4C4C"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M7.859 12.768C7.699 12.768 7.539 12.708 7.418 12.585C7.173 12.341 7.173 11.946 7.418 11.702L11.701 7.418C11.945 7.173 12.341 7.173 12.585 7.418C12.829 7.662 12.829 8.058 12.585 8.302L8.301 12.585C8.179 12.708 8.019 12.768 7.859 12.768Z"
          fill="#4C4C4C"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M12.088 12.917C11.627 12.917 11.25 12.544 11.25 12.083C11.25 11.623 11.619 11.25 12.080 11.25H12.088C12.548 11.25 12.921 11.623 12.921 12.083C12.921 12.544 12.548 12.917 12.088 12.917Z"
          fill="#4C4C4C"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M7.923 8.749C7.463 8.749 7.086 8.376 7.086 7.915C7.086 7.455 7.455 7.082 7.916 7.082H7.923C8.384 7.082 8.757 7.455 8.757 7.915C8.757 8.376 8.384 8.749 7.923 8.749Z"
          fill="#4C4C4C"/>
      </svg>

      <span class="ml-2-5">Member & Point</span>
    </a>
    <hr class="my-0" />

    <!-- TRANSACTION HISTORY -->
    <a class="body-2-4 p-3 d-flex align-items-center justify-content-left menu-account-item" :href="$getCommunityUrl('/account/transaction-history')" target="_blank">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M13.1 14.1H7.1C6.7 14.1 6.5 13.9 6.5 13.5C6.5 13.2 6.7 12.9 7.1 12.9H13.1C13.4 12.9 13.7 13.2 13.7 13.5C13.7 13.9 13.4 14.1 13.1 14.1Z"
          fill="#4C4C4C"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M13.1 10.7H7.1C6.7 10.7 6.5 10.4 6.5 10C6.5 9.7 6.7 9.4 7.1 9.4H13.1C13.4 9.4 13.7 9.7 13.7 10C13.7 10.4 13.4 10.7 13.1 10.7Z"
          fill="#4C4C4C"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M9.4 7.2H7.1C6.7 7.2 6.5 6.9 6.5 6.6C6.5 6.2 6.7 5.9 7.1 5.9H9.4C9.7 5.9 10 6.2 10 6.6C10 6.9 9.7 7.2 9.4 7.2Z"
          fill="#4C4C4C"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M13.3 2.9L6.9 2.9C4.9 2.9 3.8 4.1 3.8 6.1V13.8C3.8 15.8 4.9 17 6.9 17H13.3C15.2 17 16.4 15.8 16.4 13.8V6.1C16.4 4.1 15.2 2.9 13.3 2.9ZM6.9 18.3C4.3 18.3 2.5 16.5 2.5 13.8V6.1C2.5 3.4 4.2 1.7 6.9 1.7H13.3C15.9 1.7 17.6 3.5 17.6 6.1V13.8C17.6 16.5 15.9 18.3 13.3 18.3H6.9Z"
          fill="#4C4C4C"/>
      </svg>
      <span class="ml-2-5">Your Transactions</span>
    </a>
    <hr class="my-0" />

    <!-- PROFILE -->
    <a class="body-2-4 p-3 d-flex align-items-center justify-content-left menu-account-item" :href="$getCommunityUrl('/account/profile')" target="_blank">
      <img 
        src="../../assets/img/icon/menu-navbar/Login.png" 
        width="20"
        :alt="getMerchant.name">
      <span class="ml-2-5">Profile</span>
    </a>
    <hr class="my-0" />

    <!-- CHANGE PASSWORD -->
    <a class="body-2-4 p-3 d-flex align-items-center justify-content-left menu-account-item" :href="$getCommunityUrl('/account/change-password')" target="_blank">
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M6.384 2.914C4.277 2.914 2.914 4.358 2.914 6.594V13.401C2.914 15.637 4.277 17.081 6.384 17.081H13.607C15.717 17.081 17.081 15.637 17.081 13.401V6.594C17.081 4.358 15.717 2.914 13.609 2.914H6.384ZM13.607 18.331H6.384C3.561 18.331 1.664 16.349 1.664 13.401V6.594C1.664 3.646 3.561 1.664 6.384 1.664H13.609C16.433 1.664 18.331 3.646 18.331 6.594V13.401C18.331 16.349 16.433 18.331 13.607 18.331Z"
          fill="#4C4C4C"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M7.365 9.078C6.857 9.078 6.445 9.490 6.445 9.996C6.445 10.503 6.857 10.915 7.364 10.915C7.869 10.915 8.282 10.503 8.282 9.996C8.282 9.491 7.870 9.079 7.365 9.078ZM7.364 12.165C6.168 12.165 5.195 11.192 5.195 9.996C5.195 8.801 6.168 7.828 7.364 7.828C8.561 7.829 9.532 8.801 9.532 9.996C9.532 11.192 8.559 12.165 7.364 12.165Z"
          fill="#4C4C4C"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M14.171 12.165C13.826 12.165 13.546 11.885 13.546 11.540V10.621H8.906C8.561 10.621 8.281 10.342 8.281 9.996C8.281 9.651 8.561 9.371 8.906 9.371H14.171C14.516 9.371 14.796 9.651 14.796 9.996V11.540C14.796 11.885 14.516 12.165 14.171 12.165Z"
          fill="#4C4C4C"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M11.813 12.165C11.468 12.165 11.188 11.885 11.188 11.540V9.996C11.188 9.651 11.468 9.371 11.813 9.371C12.158 9.371 12.438 9.651 12.438 9.996V11.540C12.438 11.885 12.158 12.165 11.813 12.165Z"
          fill="#4C4C4C"/>
      </svg>

      <span class="ml-2-5">Change Password</span>
    </a>
    <hr class="my-0" />

    <!-- CURRENCY & LANGUAGE -->
    <template v-if="$is_mobile_view">
      <div @click="openCurrency()" class="body-2-4 p-3 d-flex align-items-center justify-content-left menu-account-item cursor-pointer">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_2207_3786)">
            <path
              d="M11.9887 23.3242C15.2465 23.3242 17.9067 18.5078 17.9067 12.0508C17.9067 5.5586 15.2583 0.742188 11.9887 0.742188C8.71923 0.742188 6.0708 5.5586 6.0708 12.0508C6.0708 18.5078 8.73096 23.3242 11.9887 23.3242ZM11.9887 2.16016C14.2856 2.16016 16.3364 6.73047 16.3364 12.0508C16.3364 17.2773 14.2856 21.8945 11.9887 21.8945C9.69189 21.8945 7.64111 17.2773 7.64111 12.0508C7.64111 6.73047 9.69189 2.16016 11.9887 2.16016ZM11.227 0.90625V23.1015H12.7622V0.90625H11.227ZM11.9887 16.4336C8.37939 16.4336 5.18017 17.3828 3.53955 18.8945L4.72314 19.8672C6.27002 18.6367 8.78955 17.9687 11.9887 17.9687C15.1879 17.9687 17.7075 18.6367 19.2544 19.8672L20.4379 18.8945C18.7973 17.3828 15.5981 16.4336 11.9887 16.4336ZM22.8051 11.2539H1.17236V12.789H22.8051V11.2539ZM11.9887 7.67969C15.5981 7.67969 18.7973 6.73047 20.4379 5.21875L19.2544 4.2461C17.7075 5.46484 15.1879 6.14453 11.9887 6.14453C8.78955 6.14453 6.27002 5.46484 4.72314 4.2461L3.53955 5.21875C5.18017 6.73047 8.37939 7.67969 11.9887 7.67969ZM11.9887 23.9804C18.5278 23.9804 23.9418 18.5547 23.9418 12.0273C23.9418 5.48828 18.5161 0.0742188 11.977 0.0742188C5.4497 0.0742188 0.0356445 5.48828 0.0356445 12.0273C0.0356445 18.5547 5.46142 23.9804 11.9887 23.9804ZM11.9887 22.3867C6.32861 22.3867 1.62939 17.6875 1.62939 12.0273C1.62939 6.36719 6.31689 1.66797 11.977 1.66797C17.6372 1.66797 22.3481 6.36719 22.3481 12.0273C22.3481 17.6875 17.6489 22.3867 11.9887 22.3867Z"
              fill="#4C4C4C" />
          </g>
          <defs>
            <clipPath id="clip0_2207_3786">
              <rect width="23.9062" height="23.918" fill="white" transform="translate(0.0356445 0.0742188)" />
            </clipPath>
          </defs>
        </svg>
        <span class="ml-2-5">Currency</span>
      </div>
      <hr class="my-0" />
    </template>

    <!-- LOGOUT -->
    <button @click="logoutCurrentUser" class="body-2-4 p-3 text-danger d-flex align-items-center menu-account-item w-100 bg-white border-0">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M11.319 22H6.433C3.989 22 2 20.011 2 17.565V6.436C2 3.99 3.989 2 6.433 2H11.308C13.754 2 15.744 3.99 15.744 6.436V7.368C15.744 7.782 15.408 8.118 14.994 8.118C14.58 8.118 14.244 7.782 14.244 7.368V6.436C14.244 4.816 12.927 3.5 11.308 3.5H6.433C4.816 3.5 3.5 4.816 3.5 6.436V17.565C3.5 19.184 4.816 20.5 6.433 20.5H11.319C12.931 20.5 14.244 19.188 14.244 17.576V16.633C14.244 16.219 14.58 15.883 14.994 15.883C15.408 15.883 15.744 16.219 15.744 16.633V17.576C15.744 20.016 13.758 22 11.319 22Z"
          fill="#DA0000"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M21.787 12.75H9.746C9.332 12.75 8.996 12.414 8.996 12C8.996 11.586 9.332 11.25 9.746 11.25H21.787C22.201 11.25 22.537 11.586 22.537 12C22.537 12.414 22.201 12.75 21.787 12.75Z"
          fill="#DA0000"/>
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M18.859 15.666C18.667 15.666 18.474 15.593 18.328 15.445C18.036 15.151 18.037 14.677 18.33 14.385L20.724 12L18.33 9.616C18.037 9.324 18.035 8.85 18.328 8.556C18.62 8.262 19.094 8.262 19.388 8.554L22.316 11.469C22.458 11.609 22.537 11.801 22.537 12C22.537 12.199 22.458 12.391 22.316 12.531L19.388 15.447C19.242 15.593 19.05 15.666 18.859 15.666Z"
          fill="#DA0000"/>
      </svg>
      <span class="ml-2-5">Logout</span>
    </button>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { get } from '../../services';

  export default {
    data(){
      return {
        membership: {}
      }
    },
    mounted(){
      if(this.useMembership){
        this.getCommunityMembership();
      }
    },
    computed:{
      ...mapGetters(['getCurrentUser', '', 'getMerchant']),
      fullName(){
        if(this.$isEmpty(this.getCurrentUser)) return "";
        const { prefix_name = "", first_name = "", last_name = "" } = this.getCurrentUser;
        return this.$generateFullName(prefix_name, first_name, last_name);
      },
      useMembership(){
        const { use_community_membership = false } = this.getMerchant.community;
        return this.$isNotEmptyV2(this.getCurrentUser) && use_community_membership
      }
    },
    methods:{
      ...mapActions(['logout']),
      logoutCurrentUser(){
        this.logout();
        setTimeout(() => {
          window.location.reload()
        }, 500);
      },
      async getCommunityMembership() {
        try {
          const apiParams = { community_id: this.getMerchant.community.id }
          const apiResponse = await get("COMMUNITY", "membership/user-member-card-level-up", apiParams);
          const {success, data, message} = apiResponse.data;
          if(!success) throw new Error(message);
          
          this.membership = data
          
        } catch (error) {
          console.log("MEMBERSHIP ERROR GET DATA : ", error.message)
        }
      },
      openCurrency(){
        this.$emit('openCurrency', true);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/userMenuDetail.vue